import { render, staticRenderFns } from "./email-modal-popup.component.vue?vue&type=template&id=67e9341c"
import script from "./email-modal-popup.component.ts?vue&type=script&lang=ts&external"
export * from "./email-modal-popup.component.ts?vue&type=script&lang=ts&external"
import style0 from "./email-modal-popup.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports